import ReactDOM from "react-dom";
import React, { useEffect } from "react";
import Shadow from "./Shadow";
import { IoClose } from "react-icons/io5";

const Modal = ({ children, title, onClose, isOpen }) => {
  useEffect(() => {
    if (onClose && isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [onClose, isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="">
      <Shadow />
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div className="bg-white border-2 p-4 rounded-lg relative">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
            aria-label="Close modal"
          >
            <IoClose size={24} />
          </button>
          <h1 className="text-xl font-bold mb-4">{title}</h1>
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;

// fixed items - center justify - center   border - 2 transition ease - out duration - 300
